module.exports = __webpack_public_path__ + "sc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sc.svg
// module id = 1046
// module chunks = 0